import React from 'react';
import Paper from '@mui/material/Paper';
import './Adminhomepage.scss';
import {HOMEPAGE_CONTENT_SUBTEXT5,HOMEPAGE_CONTENT_LINEITEMHEADING1,HOMEPAGE_CONTENT_LINEITEMTEXT1, HOMEPAGE_CONTENT_LINEITEMHEADING2,HOMEPAGE_CONTENT_LINEITEMTEXT2,HOMEPAGE_CONTENT_SUBHEADER5, HOMEPAGE_CONTENT_SUBHEADER4, HOMEPAGE_CONTENT_SUBHEADER1, HOMEPAGE_CONTENT_SUBTEXT1_LINE2, HOMEPAGE_CONTENT_SUBHEADER2, HOMEPAGE_CONTENT_SUBHEADER3, HOMEPAGE_CONTENT_SUBTEXT3, HOMEPAGE_CONTENT_SUBTEXT4, HOMEPAGE_CONTENT_SUBTEXT2, HOMEPAGE_CONTENT_SUBTEXT1, HOMEPAGE_CONTENT_HEADER, HOMEPAGE_TEXT} from '../../../constants/Admin/adminConstants';
import { Divider } from '@mui/material';

const  Adminhomepage = () => {
 

	return (
		<>
			<div className='adminhomepage'>

				<Paper className='page-header'>
					<h4 className='title-class' data-testid='admin-homepage'>{HOMEPAGE_TEXT}</h4>
				</Paper>

				<Paper className='adminhomepage-content'>
					<div>
						<p className='adminhomepage-content-header' data-testid='content-header'>{HOMEPAGE_CONTENT_HEADER}</p>
						<Divider></Divider>
						<div className='adminhomepage-content-section'>
							<p className='adminhomepage-content-header-text' >{HOMEPAGE_CONTENT_SUBTEXT1}</p>
							{/*<p className='adminhomepage-content-header-text' >{HOMEPAGE_CONTENT_SUBTEXT1_LINE2}</p>*/}
							<p className='adminhomepage-content-subheader' data-testid='content-subheader'>{HOMEPAGE_CONTENT_SUBHEADER1}</p>
							<p className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_SUBTEXT2}</p>
							<p className='adminhomepage-content-subheader'>{HOMEPAGE_CONTENT_SUBHEADER2}</p>
							<p className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_SUBTEXT3}</p>
							<p className='adminhomepage-content-subheader'>{HOMEPAGE_CONTENT_SUBHEADER3}</p>
							<div className='merchant-section'>
								<li className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_LINEITEMHEADING1} {HOMEPAGE_CONTENT_LINEITEMTEXT1}</li>
								<li className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_LINEITEMHEADING2} {HOMEPAGE_CONTENT_LINEITEMTEXT2}</li>
							</div>
							<p className='adminhomepage-content-subheader'>{HOMEPAGE_CONTENT_SUBHEADER4}</p>
							<p className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_SUBTEXT4}</p>
							
							<p className='adminhomepage-content-subheader'>{HOMEPAGE_CONTENT_SUBHEADER5}</p>
							<p className='adminhomepage-content-header-text'>{HOMEPAGE_CONTENT_SUBTEXT5}</p>
							</div>
					</div>
				</Paper>

			</div>


		</>)
}

 export default Adminhomepage;
